angular
    .module('tradersyard')
    .controller('document-filter-ctrl', [
        '$scope',
        '$rootScope',
        function ($scope, $root) {
            $scope.ui = {
                mode: 'all',
            };

            $scope.attachment = {
                document: 'Document',
                spreadsheet: 'Spreadsheet',
                presentation: 'Presentation',
                archive: 'Archive',
                agenatrader: 'Agenatrader',
            };

            $scope.filter = {
                attachment: {
                    document: true,
                    spreadsheet: true,
                    presentation: true,
                    archive: true,
                    agenatrader: true,
                },
                select: {
                    attach: {
                        all: true,
                    },
                },
            };

            $scope.query = {
                attach: [],
                compile: function () {
                    $scope.query.attach = [];

                    for (var type in $scope.filter.attachment) {
                        if ($scope.filter.attachment[type] === true) $scope.query.attach.push(type);
                    }
                },
            };

            $scope.filtrate = function () {
                var $params = {
                    type: encodeURIComponent($scope.query.attach.join(',')),
                };

                $root.$broadcast('document-filter-update', $params);
            };

            $scope.fn = {
                attach: {
                    all: function () {
                        for (var type in $scope.filter.attachment)
                            $scope.filter.attachment[type] = $scope.filter.select.attach.all;

                        $scope.query.compile();
                    },
                    change: function () {
                        $scope.filter.select.attach.all = false;

                        for (var type in $scope.filter.attachment) {
                            if ($scope.filter.attachment[type] === true) {
                                $scope.filter.select.attach.all = true;
                                break;
                            }
                        }

                        $scope.query.compile();
                    },
                },
                filter: {
                    all: function () {
                        $scope.ui.mode = 'all';

                        var $q = {};

                        $scope.fn.filter.cast($q);
                    },
                    man: function () {
                        $scope.ui.mode = 'man';
                        var $q = {
                            type: encodeURIComponent($scope.query.attach.join(',')),
                        };

                        $scope.fn.filter.cast($q);
                    },
                    cast: function ($query) {
                        $root.$broadcast('document-filter-update', $query);
                    },
                },
            };

            $scope.fn.attach.all();
        },
    ])
    .controller('document-query-ctrl', [
        '$scope',
        'graph-document-factory',
        '$flex.scroll',
        function ($scope, $factory, $scroll) {
            $scope.nodes = [];
            $scope.process = 0;
            $scope.params = {
                page: 0,
            };

            $scope.$on('document-filter-update', function ($e, $query) {
                $scope.nodes = [];
                $scope.params = $query;
                $scope.params.page = 0;

                $scroll.renew('document');

                $scope.query();
            });

            $scope.upload = {
                document: function (node) {
                    if ($scope.form.document.$valid === true) {
                        var fd = new FormData();
                        fd.append('document', $scope.document.file);
                        fd.append('name', $scope.document.name);

                        $factory
                            .entry(undefined, node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $scope.nodes.unshift(response.data.data);
                                }
                            });
                    }
                },
            };

            $scope.query = function (next) {
                ++$scope.params.page;
                $scope.process = 1;

                $factory
                    .entry('user', 'me')
                    .query({
                        params: $scope.params,
                    })
                    .then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            $scope.nodes = $scope.nodes.concat(response.data.data);

                            if (next) next();
                        }

                        $scope.process = 0;
                    });
            };
        },
    ]);
